import { Component, ComponentRef, OnInit, ViewContainerRef } from '@angular/core';
import { FormService } from '@services/form.service';
import { FormDetailComponent } from '../base/form-detail/form-detail.component';
import { FormFieldDefinition } from '@models/form-field-definition';
import { Form } from '@models/form';

@Component({
    selector: 'cp-account-users',
    templateUrl: './account-users.component.html',
    styleUrls: ['./account-users.component.less'],
    standalone: false
})
export class AccountUsersComponent implements OnInit {
    constructor(private _formService: FormService, private _viewContainerRef: ViewContainerRef) {}

    ngOnInit(): void {
        this._formService.getForm('cpAccountUsers').subscribe(
            (fields: FormFieldDefinition[]) => {
                this.showForm('cpAccountUsers', 'cpAccountUsers', fields);
            }
        );
    }

    private showForm(formId: string, dataQueryId: string, fields: FormFieldDefinition[]) {
        const ref: ComponentRef<FormDetailComponent> =
            this._viewContainerRef.createComponent(FormDetailComponent);

        ref.instance.formId = formId;
        ref.instance.pageId = 'home';
        ref.instance.fields = Form.convertToFormFields(fields);
        ref.instance.dataQueryId = dataQueryId;
        ref.instance.autoRunDataQuery = true;
        ref.instance.isLoginForm = false;
        ref.instance.isAuthenticationForm = false;
        ref.changeDetectorRef.detectChanges();
    }
}
